import Icon from '../components/Icon.vue'

Icon.register({"paperclip":{"width":448,"height":512,"paths":[{"d":"M43.2 466.1C-15.2 405.9-14.1 308.6 44.6 248.6L254.4 34C298.7-11.3 370.7-11.3 415.1 34 459 78.9 459 151.3 415.1 196.3L232.2 383.1C202.4 413.7 153.6 413.2 124.2 382.1 96 352.2 96.9 304.7 125.7 275.2L269.4 128.3C275.6 122 285.7 121.9 292.1 128.1L314.9 150.5C321.2 156.7 321.3 166.8 315.2 173.1L171.4 319.9C166.5 325 166.2 333.4 170.8 338.2 175.2 342.9 182 342.9 186.5 338.4L369.3 151.5C388.9 131.5 388.9 98.8 369.3 78.7 350.1 59.1 319.3 59.1 300.2 78.7L90.4 293.3C55.6 328.9 55.1 386.4 89.2 421.6 123.2 456.7 178.2 456.7 212.3 421.9L384.3 245.9C390.5 239.6 400.6 239.5 406.9 245.6L429.8 268C436.1 274.2 436.3 284.3 430.1 290.6L258 466.6C198.4 527.6 102.1 526.8 43.2 466.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/paperclip.js
// module id = null
// module chunks = 